export interface SuggestionWindow {
  start: Date;
  end: Date;
}

const DEFAULT_WINDOW_HOURS = 24;

/** Neither the job nor the trip carries a pickup time yet, so the picker ranks for the next day from when it opened. */
export function defaultSuggestionWindow(now: Date): SuggestionWindow {
  return { start: now, end: new Date(now.getTime() + DEFAULT_WINDOW_HOURS * 60 * 60 * 1000) };
}
